// Cloudflare Turnstile is optional: with no site key set, no widget shows and no token is sent.
export const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export function getTurnstileSiteKey() {
  return (process.env.REACT_APP_TURNSTILE_SITE_KEY || '').trim();
}

export function isTurnstileEnabled() {
  return getTurnstileSiteKey() !== '';
}

// Supabase Auth verifies the token server-side when CAPTCHA protection is switched on for the project.
export function captchaOptions(token) {
  return isTurnstileEnabled() && token ? { captchaToken: token } : {};
}

// True when a captcha is required but not yet solved, so the form should stay disabled.
export function isCaptchaPending(token) {
  return isTurnstileEnabled() && !token;
}
